import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { DependencyResponse } from '../../../../shared/dependenciesV2';

import { getBaseDependencyFetchQueryKey } from './queryKey';

export const getGlobalDependencyQueryKey = (dependencyRevisionLocator: string): QueryKey => [
  ...getBaseDependencyFetchQueryKey(dependencyRevisionLocator),
];

/**
 * Hook to fetch a single dependency in the global scope.
 * @param dependencyRevisionLocator - The locator of the dependency revision.
 * @param shouldFetch - Whether to fetch the dependency.
 * @returns The dependency.
 */
export default function useGetGlobalDependency(
  dependencyRevisionLocator: string,
  shouldFetch: boolean = true,
) {
  const queryKey: QueryKey = getGlobalDependencyQueryKey(dependencyRevisionLocator);

  const queryFn = () => get<DependencyResponse>(`/api/v2/dependencies/${nuc(dependencyRevisionLocator)}`);

  return useQuery<DependencyResponse>({
    queryKey,
    queryFn,
    enabled: shouldFetch,
  });
}
